import { useState, useMemo } from "react";

export const useAirportSelection = () => {
  const airports = useMemo<string[]>(() => {
    const stored = sessionStorage.getItem("airportServicedByVendor") || "";
    return stored
      .split(",")
      .map((a) => a.trim())
      .filter(Boolean);
  }, []);

  const [selectedAirport, setSelectedAirport] = useState<string>(
    airports[0] || ""
  );

  return {
    airports,
    selectedAirport,
    setSelectedAirport,
    hasMultipleAirports: airports.length > 1,
  };
};
